// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rIId","badges":"styles_badges__3kYvv"};